import React, { useEffect, useState } from 'react';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { ShoppingBagIcon } from 'lucide-react';
interface Purchase {
  name: string;
  location: string;
  timeAgo: string;
}
const purchases: Purchase[] = [{
  name: 'María G.',
  location: 'Ciudad de México, México',
  timeAgo: 'hace 2 minutos'
}, {
  name: 'John D.',
  location: 'Los Angeles, Estados Unidos',
  timeAgo: 'hace 5 minutos'
}, {
  name: 'Carmen S.',
  location: 'Guadalajara, México',
  timeAgo: 'hace 8 minutos'
}, {
  name: 'Sarah M.',
  location: 'Miami, Estados Unidos',
  timeAgo: 'hace 3 minutos'
}, {
  name: 'Roberto L.',
  location: 'Monterrey, México',
  timeAgo: 'hace 6 minutos'
}, {
  name: 'Michael R.',
  location: 'New York, Estados Unidos',
  timeAgo: 'hace 4 minutos'
}, {
  name: 'Ana P.',
  location: 'Puebla, México',
  timeAgo: 'hace 7 minutos'
}, {
  name: 'Jennifer K.',
  location: 'Houston, Estados Unidos',
  timeAgo: 'hace 9 minutos'
}, {
  name: 'Luis F.',
  location: 'Tijuana, México',
  timeAgo: 'hace 1 minuto'
}, {
  name: 'David W.',
  location: 'Chicago, Estados Unidos',
  timeAgo: 'hace 10 minutos'
}];
export function PurchaseNotification() {
  const [currentPurchase, setCurrentPurchase] = useState<Purchase | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      setCurrentPurchase(randomPurchase);
      setIsVisible(true);
      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Show first notification after 3 seconds
    const initialTimeout = setTimeout(showNotification, 3000);
    // Then show every 15 seconds
    const interval = setInterval(showNotification, 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  if (!currentPurchase || !isVisible) return null;
  return <Box position="fixed" bottom={{
    base: 4,
    md: 8
  }} left={{
    base: 4,
    md: 8
  }} zIndex={9999} bg="linear-gradient(135deg, rgba(127, 29, 29, 0.95) 0%, rgba(0, 0, 0, 0.95) 100%)" backdropFilter="blur(10px)" borderRadius="xl" shadow="2xl" borderWidth="2px" borderColor="red.500" p={4} maxW={{
    base: '90%',
    sm: '350px'
  }} animation="slideIn 0.3s ease-out" sx={{
    '@keyframes slideIn': {
      from: {
        transform: 'translateX(-100%)',
        opacity: 0
      },
      to: {
        transform: 'translateX(0)',
        opacity: 1
      }
    }
  }} data-id="element-239">
      <HStack spacing={3} align="start" data-id="element-240">
        <Box bg="green.500" p={2} borderRadius="full" flexShrink={0} data-id="element-241">
          <ShoppingBagIcon size={20} color="white" data-id="element-242" />
        </Box>
        <VStack align="start" spacing={0} flex="1" data-id="element-243">
          <Text fontSize="sm" fontWeight="bold" color="white" data-id="element-244">
            ✅ Compra realizada
          </Text>
          <Text fontSize="xs" color="gray.300" data-id="element-245">
            <Text as="span" fontWeight="semibold" color="yellow.300" data-id="element-246">
              {currentPurchase.name}
            </Text>{' '}
            de {currentPurchase.location}
          </Text>
          <Text fontSize="xs" color="gray.400" data-id="element-247">
            {currentPurchase.timeAgo}
          </Text>
        </VStack>
      </HStack>
    </Box>;
}